import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Page, TextStyleBody } from '@style/Shared';
import Menu from '@client/modules/Menu/Menu';
import GotoElement from '@client/core/utils/GotoElement';
import { Colors, presetColors } from '@client/style/Variables';
import MyPageFavourites from '@client/modules/MyPage/MyPageFavourites';
import SimpleFooter from '@client/modules/Footers/SimpleFooter';
import MagicModuleSwitcher from '@client/modules/MagicModuleSwitcher';
import { TextStyle } from '@client/style/TextStyles';
import { useAuthenticatedUser } from '@client/utils/AuthStore';
import FilterStore from '@client/modules/ListModules/FilterStore';
import { DateUtils } from '@client/core/utils/DateUtils';
import Site from '@client/store/Site';

const StyledPage = styled(Page)<{ $bg?: string; $fg?: string }>`
	background-color: ${props => props.$bg || presetColors.nude};
	color: ${props => props.$fg || Colors.darkText};
	min-height: 100vh;
`;

const Title = styled.h1`
	width: 100%;
	text-align: center;
	${TextStyle.family('title')}
	${TextStyle.weight('bold')}
	${TextStyle.size('p2', 'h2')}
`;

const NotAuthenticatedText = styled.h2`
	${TextStyleBody}
	padding-top: 100px;
	text-align: center;
`;

export default function MyPage(props: {
	content?: any;
	backgroundColorLink?: { color: string; contrastColor: string };
}) {
	const global = Site.use(state => state.global) as any;
	const user = useAuthenticatedUser();

	useEffect(() => {
		// FilterStore.setTagFilters(props.content._oddTags);
		// FilterStore.setLocationFilters(props.content._locationTags);
		FilterStore.setDateFilters(DateUtils.getDaysListFromTo(new Date(global.startDate), new Date(global.endDate)));
	}, []);

	return (
		<StyledPage $bg={props.backgroundColorLink?.color} $fg={props.backgroundColorLink?.color}>
			<Menu
				onLogoClick={() => GotoElement.Instance.scrollToElementWithId(`module_${props.content.startId}`)}
				specificColor={Colors.footerDarkBackground}
			/>

			<Title>{props.content.title}</Title>

			{user ? (
				<MyPageFavourites artists={props.content._artists} />
			) : (
				<NotAuthenticatedText>Log ind for at se din side</NotAuthenticatedText>
			)}

			<MagicModuleSwitcher modules={props.content ? props.content.modules : []} />

			<SimpleFooter />
		</StyledPage>
	);
}
